import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import { withStyles } from "@mui/styles";
import {
  Table,
  TableHead,
  TableCell,
  TableRow,
  TableBody,
  FormControl,
  TableFooter,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import Panel from "common/components/Panel";
import Resource from "common/components/Resource";
import Pagination from "common/components/Pagination";
import DebouncedTextField from "common/components/DebouncedTextField";

class List extends React.Component {
  state = {
    search: "",
  };

  handleSearchChange = (value) => this.setState({ search: value });

  render() {
    const { classes, match, history } = this.props;
    const { search } = this.state;
    const queryParams = {};
    if (search) {
      queryParams.name_like = search;
    }

    return (
      <Panel title="View Cities">
        <Grid container direction="column" spacing={2}>
          <Grid size={{ xs: 4 }}>
            <FormControl className={classes.search}>
              <DebouncedTextField
                id="search"
                label="Search by name"
                onChange={this.handleSearchChange}
                delay={500}
              />
            </FormControl>
          </Grid>
        </Grid>
        <Resource
          name="cities"
          queryParams={queryParams}
          render={(cities, { removeOne, prevPage, nextPage, page }) => (
            <Table className={classes.table}>
              <TableHead>
                <TableRow>
                  <TableCell>ID</TableCell>
                  <TableCell>Name</TableCell>
                  <TableCell>Region</TableCell>
                  <TableCell>Country</TableCell>
                  <TableCell>Last Updated</TableCell>
                  <TableCell>Delete</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {cities.length ? (
                  cities.map((city) => (
                    <TableRow hover key={city.id}>
                      <TableCell>{city.id}</TableCell>
                      <TableCell
                        className={classes.clickable}
                        onClick={() => history.push(`${match.url}/${city.id}`)}
                      >
                        {city.name}
                      </TableCell>
                      <TableCell>{city.region}</TableCell>
                      <TableCell>{city.country}</TableCell>
                      <TableCell>
                        {moment(city.updated_at).format("YYYY-MM-DD")}
                      </TableCell>
                      <TableCell>
                        <IconButton>
                          <DeleteIcon onClick={() => removeOne(city.id)} />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={6}>No additional data found.</TableCell>
                  </TableRow>
                )}
              </TableBody>
              <TableFooter>
                <TableRow>
                  <TableCell colSpan={6} className={classes.pagination}>
                    <Pagination
                      page={page}
                      nextPage={nextPage}
                      prevPage={prevPage}
                      items={cities}
                    />
                  </TableCell>
                </TableRow>
              </TableFooter>
            </Table>
          )}
        />
      </Panel>
    );
  }
}

const styles = (theme) => ({
  clickable: {
    cursor: "pointer",
    color: theme.palette.primary.light,
    fontWeight: "bold",
  },
  table: {
    minWidth: 700,
  },
  pagination: {
    textAlign: "right",
  },
  search: {
    paddingTop: theme.spacing(1),
  },
});

List.propTypes = {
  classes: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
};

export default withStyles(styles)(List);
